import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { GeneralFormNew } from './general-drawer-form-new';

export type PermitsDrawerProps = {
  readonly project: Project;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly isOpen: boolean;
  readonly formId: string;
};

export function GeneralNewDrawer({ project, onSubmit, onClose, isOpen, formId }: PermitsDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('General Information')} open={isOpen} onClose={onClose} footer={footer}>
      <GeneralFormNew
        id={formId}
        project={project}
        onSubmit={(data: any) => {
          onSubmit(data, t('General Information section has been updated'));
        }}
      />
    </Drawer>
  );
}
